import { render, staticRenderFns } from "./vgpTabs.vue?vue&type=template&id=4311f52a&"
import script from "./vgpTabs.vue?vue&type=script&lang=js&"
export * from "./vgpTabs.vue?vue&type=script&lang=js&"
import style0 from "./less/tabs.less?vue&type=style&index=0&module=%24&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style0.locals || style0)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./less/tabs.less?vue&type=style&index=0&module=%24&lang=css&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("./less/tabs.less?vue&type=style&index=0&module=%24&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("4311f52a")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4311f52a')) {
      api.createRecord('4311f52a', component.options)
    } else {
      api.reload('4311f52a', component.options)
    }
    module.hot.accept("./vgpTabs.vue?vue&type=template&id=4311f52a&", function () {
      api.rerender('4311f52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/tabs/vgpTabs.vue"
export default component.exports